import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "@fontsource/outfit/700.css";

import { App } from "./App.js";
import { AppErrorBoundary } from "./AppErrorBoundary.js";
import "./styles.css";
import "./v2.css";
import "./investor-experience.css";
import "./polyfuture-design.css";
import "./polyfuture-concept-contract.css";
import "./v3-shell.css";
import "./trader.css";
import "./research-results.css";
import "./attachments.css";
import "./tokens.css";
import { applyTheme, readStoredTheme } from "./theme.js";
import { captureAlpacaOAuthCallback } from "./alpacaOAuthCallback.js";

applyTheme(readStoredTheme());
// ADR-100: take Alpaca's one-time answer out of the address before routing reads or rewrites it.
captureAlpacaOAuthCallback(window.location, window.history);

const element = document.getElementById("root");
if (element === null) throw new Error("root element is missing");
createRoot(element).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
